export default function Spinner() {
  return (
    <svg viewBox="0 0 50 50" className="h-6 animate-spin" role="status">
      <circle
        cx="25"
        cy="25"
        r="20"
        fill="none"
        strokeWidth="5"
        stroke="rgba(0, 0, 0, 0.8)"
        strokeLinecap="round"
        strokeDasharray="90, 150"
      ></circle>
    </svg>
  );
}
